// extracted by mini-css-extract-plugin
module.exports = {"container":"xjbva","header":"_1ZsXS","content":"_1gbVs","controls":"_1PvQC"};